"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoarWhelpsAbilityHandler = exports.MoarWhelpsActorAbilityFactory = exports.MoarWhelpsAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
class MoarWhelpsAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MoarWhelps;
        this.__typeName = "MoarWhelps";
    }
}
exports.MoarWhelpsAbilityArgs = MoarWhelpsAbilityArgs;
let MoarWhelpsActorAbilityFactory = class MoarWhelpsActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MoarWhelps", "Self", 10);
    }
};
MoarWhelpsActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MoarWhelps")
], MoarWhelpsActorAbilityFactory);
exports.MoarWhelpsActorAbilityFactory = MoarWhelpsActorAbilityFactory;
let MoarWhelpsAbilityHandler = class MoarWhelpsAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
MoarWhelpsAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MoarWhelps)
], MoarWhelpsAbilityHandler);
exports.MoarWhelpsAbilityHandler = MoarWhelpsAbilityHandler;
